import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import VestingCrowdSale from "./../assests/data/VestingCrowdSale.json";
import { useState } from "react";
import { BigNumber, ethers } from "ethers";
import {
  Avatar,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  Link,
  TextField,
} from "@mui/material";
import CountDown from "./CountDown";
import CircularProgress from '@mui/material/CircularProgress';
import { Fade } from 'react-reveal';
import tokenIcon from './../assests/images/EscaCoin-logo.png';
import { CancelOutlined, CheckOutlined, ErrorOutline } from "@mui/icons-material";

const theme = createTheme();

const contractAddress = process.env.REACT_APP_Contract_Address;

var metaMaskInstalled = false;
if (typeof window.ethereum !== 'undefined') {
  console.log('MetaMask is installed!');
  metaMaskInstalled = true;
}

export default function LandingPage() {
  const [connectToMetaMaskBtnDisabled, setConnectToMetaMaskBtnDisabled] =
    useState(false);
  const [connected, setConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [purchaseAmount, setPurchaseAmount] = useState("0");
  const [miniumumContributionEth, setMiniumumContributionEth] = useState("0");
  const [minTokens, setMinTokens] = useState("0");
  const [open, setOpen] = React.useState(false);
  const [alertText, setAlertText] = useState("");
  const [confirmation, setConfirmation] = React.useState(false);

  const handleClose = () => {
    setAlertText("");
    setOpen(false);
    setConfirmation(false)
  };

  const roundTo = function (num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
  };

  const connectMetaMask = async () => {
    try {
      setLoading(true);
      const connection = await (window as any).ethereum.request({ method: "eth_requestAccounts" });
      console.log(connection);
      if (connection) { }
      setConnected(true);
      setConnectToMetaMaskBtnDisabled(true);
      await setMinContribution();
      setLoading(false);
    } catch (error) {
      if (error.code == "-32603") {
        setAlertText("Switch Metamask to Smart Chain network. Instructions given Pre-sale");
      } else {
        setAlertText(error.message);
      }
      setLoading(false);
    }

  };

  const purchaseTokens = async () => {
    if (isNaN(Number(purchaseAmount)) || Number(purchaseAmount) <= 0) {
      setAlertText("Please enter a valid amount");
      setOpen(true);
      return;
    }

    try {
      const provider = new ethers.providers.Web3Provider(
        (window as any).ethereum
      );
      const signer = provider.getSigner();

      const tx = await signer.sendTransaction({
        to: contractAddress,
        value: ethers.utils.parseEther(purchaseAmount),
      });
      if (tx) {
        setConfirmation(true);
      }
    } catch (error) {
      if (error.code == "-32603") {
        setAlertText(error.data.message);
      } else {
        setAlertText(error.message);
      }
      setOpen(true);
      return;
    }
  };

  const setMinContribution = async () => {
    const provider = new ethers.providers.Web3Provider(
      (window as any).ethereum
    );
    const signer = provider.getSigner();
    const contract = new ethers.Contract(
      contractAddress!,
      VestingCrowdSale.abi,
      provider
    );
    const contractWithSigner = contract.connect(signer);

    const rate: number = await contractWithSigner.rate(); // to get sold tokens
    const minTokenRequirement: number = await contractWithSigner.minimumContribution();
    setMinTokens(minTokenRequirement.toString());
    const minCont = (1 / rate) * minTokenRequirement;
    const minContString = (roundTo(minCont, 2) + 0.01).toString();
    setMiniumumContributionEth(minContString);
  };

  const presale1Date = new Date(new Date().setDate(21)).setHours(14);
  const presale2Date = new Date(new Date().setDate(21)).setHours(2, 0, 0, 0);
  const presale3Date = new Date(new Date().setDate(21)).setHours(2, 0, 0, 0);
  const today = new Date();
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main style={{ width: "100%" }}>
        {/* Hero unit */}
        <Box
          sx={{
            pt: 8,
            pb: 6,
          }}
        >
          <Container maxWidth="lg">
            <CardContent>
              <Typography variant="h3" component="h3" className="text-uppercase">Pre-Sale - I</Typography>
            </CardContent>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} className="my-auto text-left">
                <Typography
                  variant="h5"
                  align="left"
                  color="text.secondary"
                  paragraph
                >
                  Welcome to the Esca Presale page, Here you can buy, withdraw
                  tokens, and more. MetaMask is needed for this page To learn how to
                  set it up to use Smart Chain follow instructions &nbsp;
                  <Link
                    href="https://academy.binance.com/en/articles/connecting-metamask-to-binance-smart-chain"
                    target="_blank"
                  >
                    <strong>here</strong>
                  </Link>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} >
                <CountDown />

                <Stack
                  sx={{ pt: 4 }}
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                >
                  {metaMaskInstalled ? <Button
                    className="connect-btn"
                    disabled={connectToMetaMaskBtnDisabled}
                    onClick={connectMetaMask}
                    startIcon={loading ? <CircularProgress color="inherit" /> : <Avatar src={`https://docs.metamask.io/metamask-fox.svg`} />}
                  >
                    {connected ? <small className="font-weight-bold">
                      Connected</small> : <small className="font-weight-bold">
                      Connect To MetaMask</small>}
                  </Button> : <Button
                    className="connect-btn"
                    disabled={connectToMetaMaskBtnDisabled}
                    href="https://metamask.io/"
                    target="_blank"
                  >
                    Install MetaMask <img src={`https://docs.metamask.io/metamask-fox.svg`} />
                  </Button>}
                </Stack>

              </Grid>
            </Grid>
          </Container>
        </Box>
        <Container sx={{ py: 4 }} maxWidth="md">
          {!loading && connected ? (
            <Fade bottom>
              <Card className="normal-card" sx={{ minWidth: 275 }}>
                <CardHeader title={<InputLabel>
                  <Typography variant="body1" component="div">
                    Enter the amount in BNB to purchase. Minimum contribution is {minTokens} tokens or roughly {Number(miniumumContributionEth).toFixed(2)} BNB
                  </Typography></InputLabel>} />
                <CardContent>
                  <FormControl>
                    <TextField
                      label="Enter amount"
                      value={purchaseAmount}
                      onChange={(v) => setPurchaseAmount(v.target.value)}
                      variant="outlined"
                      InputProps={{
                        endAdornment: <InputAdornment position="end">
                          <IconButton
                            aria-label="Show Buying Currency (BNB)"
                            edge="end"
                          >
                            <Typography className="font-weight-bold">BNB</Typography>
                          </IconButton>
                        </InputAdornment>,
                      }}
                    />
                  </FormControl>
                </CardContent>
                <CardActions sx={{ width: '100%', textAlign: 'center', margin: "auto" }}>
                  <Button startIcon={<Avatar src={tokenIcon} />} className="m-auto connect-btn small" size="small" onClick={purchaseTokens}>
                    <small className="font-weight-bold">Purchase</small>
                  </Button>
                </CardActions>
              </Card>
            </Fade>
          ) : (
            <></>
          )}
        </Container>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth={"sm"}
          fullWidth={true}
        >
          <DialogTitle className="font-weight-bold" sx={{ color: "red" }} id="alert-dialog-title"> <IconButton><ErrorOutline sx={{ color: "red" }} /></IconButton>{"Error"}</DialogTitle>
          <CardContent>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {alertText || "Error Occured, Please Try Later"}
              </DialogContentText>
            </DialogContent>
          </CardContent>
          <DialogActions>
            <Button className="font-weight-bold btn-danger m-auto" sx={{ background: "#ed3b58", boxShadow: "none" }} variant="contained" onClick={handleClose} autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={confirmation}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth={"sm"}
          fullWidth={true}
        >
          <CardHeader title={<DialogTitle className="font-weight-bold" sx={{ color: "green" }} id="alert-dialog-title"> <IconButton className="border">
            <CheckOutlined sx={{ color: "green" }} /></IconButton>{" Purchase Confirmation"}</DialogTitle>}
            action={<IconButton><CancelOutlined /></IconButton>} />
          <CardContent><DialogContent>
            <DialogContentText sx={{ lineHeight: '2' }} id="alert-dialog-description">
              <Typography variant="h5" className="w-100 text-center font-weight-bold text-success">{`You have purchased ${purchaseAmount} successfully`}</Typography> <br />
              <Typography className="w-100 text-center ">The all new <a className="text-decoration-none font-weight-bold" href="https://escamenu.com/" target="_blank">Esca Menu</a> will go live in this <strong>May</strong>. Join our waitlist to win some tokens when it launches</Typography>
              <Typography className="w-100 text-center ">{`Please visit out Foodie Platform to Join `}<a target="_blank" href="https://escamenu.com/"> Waitlist</a></Typography>
            </DialogContentText>
          </DialogContent></CardContent>
          <DialogActions>
            <Button onClick={handleClose} target="_blank" href="https://yo7rb9kmgq5.typeform.com/to/lP31V3vK" className="font-weight-bold connect-btn m-auto">
              Join Waitlist
            </Button>
          </DialogActions>
        </Dialog>
      </main>
    </ThemeProvider>
  );
}
